import { useTranslation } from 'react-i18next'

import { isDepositInvoice } from '@features/invoices/utils/depositInvoices/isDepositInvoice'
import { isFinalInvoice } from '@features/invoices/utils/depositInvoices/isFinalInvoice'
import { isDocumentTypeCreditNote } from '@features/invoices/utils/isDocumentTypeCreditNote'

import { useInvoice } from '../../contexts/invoiceContext'

export const InvoiceTitle = () => {
  const { t } = useTranslation()
  const { invoice, documentType } = useInvoice()

  const isCreditNote = isDocumentTypeCreditNote(documentType)
  const isDeposit = isDepositInvoice(invoice?.billingStage)
  const isFinal = isFinalInvoice(invoice?.billingStage)

  const invoiceNumber = (isCreditNote ? invoice?.creditNoteNumber : invoice?.invoiceNumber) || ''

  if (isCreditNote) {
    return t('external_invoices.view.title.credit_note', { invoiceNumber })
  }

  if (isDeposit) {
    return t('external_invoices.view.title.deposit_invoice', { invoiceNumber })
  }

  if (isFinal) {
    return t('external_invoices.view.title.final_invoice', { invoiceNumber })
  }

  return t('external_invoices.view.title.invoice', { invoiceNumber })
}
